import React from "react";
import "./DevelopmentService1.css";
import { ReactComponent as ArrowRight } from "../../assets/developementservices/arrow-right.svg";
import { Link } from "react-router-dom";

// ✅ IMPORT PNGs as URLs (not React components)
import webDev from "../../assets/developementservices/web-dev.png";
import mobileDev from "../../assets/developementservices/mobile-dev.png";
import uiDesign from "../../assets/developementservices/ui-design.png";
import softwareDev from "../../assets/developementservices/software-dev.png";
import seo from "../../assets/developementservices/seo.png";
import marketing from "../../assets/developementservices/marketing.png";
import { AnimatedButton } from "../common/AnimatedButton";
import { motion } from "framer-motion";

// ✅ Service data with icon URLs
const services = [
  {
    title: "Web Development",
    description:
      "We build and code websites that are fast-loading, stunning on any screen, and easy for visitors to become customers.",
    points: [
      "Architecture Planning",
      "Web Design",
      "Frontend Development",
      "Backend Development & API Integration",
    ],
    icon: webDev,
  },
  {
    title: "Mobile Development",
    description:
      "Pocket-size power for your brand. Rise through search rankings and attract qualified traffic with ethical, data-driven SEO.",
    points: [
      "iOS App Development",
      "Android App Development",
      "Cross Platform App Development",
    ],
    icon: mobileDev,
  },
  {
    title: "UI/UX Design",
    description:
      "Effortless designs and conversions. We combine research, empathy, and visual flair to create interfaces people get briefly.",
    points: [
      "Web Design",
      "UX Research",
      "UX UI Design",
      "Wireframing & UI Prototyping",
      "Usability Testing",
    ],
    icon: uiDesign,
  },
  {
    title: "Software Development",
    description:
      "When off-the-shelf software doesn’t meet your needs, we create custom solutions that optimize workflows and productivity.",
    points: [
      "SaaS Product Development",
      "API Development & Integration",
      "Cross Platform App Development",
    ],
    icon: softwareDev,
  },
  {
    title: "SEO",
    description:
      "Be discovered when it matters most. Rise through search rankings and attract qualified traffic with ethical, data-driven SEO.",
    points: [
      "On-Page & Off-Page SEO",
      "Technical SEO Audits",
      "Keyword Research & Strategy",
      "Performance Tracking",
    ],
    icon: seo,
  },
  {
    title: "Digital Marketing",
    description:
      "From impression to conversion, we execute campaigns that convert views into action.",
    points: [
      "Campaign Creation (Meta, Google Ads, etc.)",
      "Performance-Driven Content Marketing",
      "Social Media Strategy & Execution",
    ],
    icon: marketing,
  },
];

const DevelopmentService = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="devser-hero-section">
        <div className="devser-hero-content">
          <h1>
            Building Websites & Apps That Just Work{" "}
            <span className="devser-hero-content-bold">For You.</span>
          </h1>
          <p>
            From initial click to lasting result, we create Web, Mobile, and
            Marketing Solutions that grow your business, without the hype.
          </p>

          {/* <Link to="/ourwork" className="devser-view-work-btn">
            <span className="btn-text">View Our Work</span>
            <span className="btn-circle">
              <ArrowRight className="arrow-icon" />
            </span>
          </Link> */}
          <AnimatedButton link="/ourwork" label="View Our Work" />
        </div>
      </section>

      {/* Services Section */}
      <section className="devser-services-split-section">
        {services.map((service, index) => (
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div
              key={index}
              className={`devser-service-row ${
                index % 2 === 1 ? "reverse" : ""
              }`}
            >
              <div className="devser-service-image">
                <img
                  src={service.icon}
                  alt={`${service.title} Icon`}
                  loading="lazy"
                />
              </div>
              <div className="devser-service-info">
                <h2>{service.title}</h2>
                <p>{service.description}</p>
                <ul>
                  {service.points.map((point, i) => (
                    <motion.div
                      initial={{ opacity: 0, y: 60 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5 }}
                      viewport={{ once: true }}
                    >
                      <li key={i}>
                        <strong>{point}</strong>
                      </li>
                    </motion.div>
                  ))}
                </ul>
              </div>
            </div>
          </motion.div>
        ))}
      </section>
    </div>
  );
};

export default DevelopmentService;
